module.exports = __webpack_public_path__ + "img/home1.91c81d96.jpg";